'use client';

import React from 'react';

export const SectionIntro: React.FC = () => {
  return (
    <div className="mb-12">
      <h2 className="text-3xl lg:text-4xl font-bold text-neutral-900 mb-6">
        Understanding Your Results
      </h2>

      <h3 className="text-2xl font-bold text-neutral-900 mb-4">
        The Gap Between Your Two Scenarios
      </h3>

      <p className="text-lg text-neutral-700 leading-relaxed">
        The calculator shows you two different realities. For the strategy behind the numbers — the five channels that produce the second one — read the{' '}
        <a
          href="/guide/mortgage-marketing-strategies"
          className="text-primary-600 font-semibold hover:underline"
        >
          Hybrid Loan Officer playbook
        </a>
        .
      </p>
    </div>
  );
};
